<template>
	<div>
		<div class="spinner-border" v-if="showLoader" style="margin:auto;display:block;margin-top:60px"/>
		<div class="col-sm-12 row" v-else>
			<div class="col-sm-11">
				<div>
					<div
						class="row"
						style="border-bottom: 2px solid #115E67;margin-bottom: 10px;font-size: 20px;padding: 5px 0px 0px 5px;"
					>
						<label style="margin: 0px;">{{issueHistory.length ? issueHistory[0].sku : 'N/A'}}</label>
					</div>
					<div style="border:1px #d4d4d4 solid; padding:20px">
						<!-- <div v-for="issue of issueHistory">{{ issue }}</div> -->
						<div>
							<table class="table" v-if="issueHistory.length!=0" style="table-layout:fixed;">
								<thead style="position: sticky;">
									<tr>
										<th class="link" style="width: 10%; font-size: small;">Event Time</th>
										<th style="width:7.5%; font-size: small;"><div>Vendor</div><div>(Brand)</div></th>
										<th style="width:7.5%; font-size: small;">Vendor Code</th>
										<th style="width:10%; font-size: small;">ASIN</th>
										<th style="width:10%; font-size: small;">SKU</th>
										<th style="width:7.5%; font-size: small;">UPC</th>
										<th style="width:10%; font-size: small;">Title</th>
										<th style="width:10%; font-size: small;">Issue Category</th>
										<th style="width:10%; font-size: small;">Message</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in issueHistory" :key="item.asin + '_' + index" :class="index%2==0?'even':''">
										<td style="width:5%;font-size: x-small;"><div>{{getDate(item.event_timestamp)}}</div><div>{{getTime(item.event_timestamp)}}</div></td>
										<td style="font-size: x-small;">{{ item.brand_name || 'NOT FOUND'}} <span v-if="item.brand"> <br/> ({{item.brand}})</span></td>
										<td style="font-size: x-small;">{{item.vendor_code || 'NOT FOUND'}}</td>
										<td style="font-size: x-small;">{{ item.asin || 'NOT FOUND'}}</td>
										<td style="font-size: x-small;">{{item.sku || 'NOT FOUND'}}</td>
										<td style="font-size: x-small;">{{item.upc || 'NOT FOUND'}}</td>
										<td style="font-size: x-small;">{{item.producttitle || 'NOT FOUND'}}</td>
										<td style="font-size: x-small;">{{item.issue_category}}</td>
										<td style="font-size: x-small;">{{item.message}}</td>
									</tr>
								</tbody>
							</table>
						</div>	
					</div>
					
				</div>
			</div>
			<div class="col-sm-11">
				<div>
					<div
						class="row"
						style="border-bottom: 2px solid #115E67;margin-bottom: 10px;font-size: 20px;padding: 5px 0px 0px 5px;"
					>
						<label style="margin: 0px;">{{workHistory.length ? 'Work History': 'N/A'}}</label>
					</div>
						<div style="border:1px #d4d4d4 solid; max-height:300px; overflow:auto;">
							<div>
								<table class="table" v-if="workHistory.length!=0" style="table-layout:fixed; width: 100%;">
								<thead style="position: sticky; top: 0; background: white; z-index: 1;">
									<tr>
									<th class="link" style="width: 10%; font-size: small;">Work Timestamp</th>
									<th style="width:7.5%; font-size: small;">Work Status</th>
									<th style="width:7.5%; font-size: small;">Worked By</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in workHistory" :key="workHistory.asin + '_' + index" :class="index%2==0?'even':''">
									<td style="width:5%;font-size: x-small;">
										<div>{{getDate(item.worked_timestamp)}}</div>
										<div>{{getTime(item.worked_timestamp)}}</div>
									</td>
									<td style="font-size: x-small;">{{item.work_status || 'NOT FOUND'}}</td>
									<td style="font-size: x-small;">{{item.worked_by || 'NOT FOUND'}}</td>
									</tr>
								</tbody>
								</table>
							</div>	
						</div>
				</div>
			</div>
		</div>
		<div class="form-group row">
			<button type="button" class="btn btn-secondary" @click="backHandler">Back</button>
			<!-- <button type="button" class="btn btn-primary" @click="">'Edit'</button> -->
		</div>
	</div>
</template>

<script>
	import moment from "moment";
	import Multiselect from "vue-multiselect";

	const formatCurrency = require("format-currency");

	export default {
		name: "Detail",
		data() {
			return {
				dataList: [],
				loader: false,
				issueHistory: [],
				workHistory: [],
				brandTag: "",
				editMode: false,
				tagDefinition: [],
				brandDef: '',
			};
		},
		props: ["clientId", "profileId"],
		components: {
			moment,
			Multiselect
		},
		async mounted() {
			this.$store.dispatch("callAnalytics", {data:window.location.href, this:this, type:'AccountDetails'})

			let vm = this;
			const params = this.$route.params
			params.isSeller = this.$store.state.isSeller
			console.log(params)
			this.issueHistory = await this.$store.dispatch("productAlerts/getProductHistory", params)
			// console.log(this.issueHistory)

			this.workHistory = await this.$store.dispatch("productAlerts/getWorkHistory", params)
			// console.log('WORK HISTORY: ', this.workHistory)
		},
		methods: {
			getDate(data){
				return moment(data).local().format("YYYY-MM-DD")
			},
			getTime(data){
				return moment(data).local().format("hh:mm A")
			},
			backHandler() {
				this.$router.back()
			},
		},
		computed: {
			showLoader: {
				get() {
					return this.$store.getters["getShowLoader"];
				},
			},
		}
	};
</script>

<style lang="scss">
.label-wrapper-style {
	color: #888888;
}
.label-value-wrapper-style {
	margin: 0px;
}
.label-not-provided-wrapper {
	color: #e1dfdf;
}
.capital {
	text-transform: capitalize !important
}
.tag-button {
	color: #fff;
	background-color: #888888;
}
.tag_label{
	display: inline-block !important; 
	padding: 5px !important; 
	margin: 2px !important; 
	max-width:calc(100%) !important; 
	text-overflow: ellipsis !important; 
	white-space: nowrap !important; 
	overflow: hidden !important;
}
.brand{
	background-color: #2F5BC2 !important;
}
.cat{
	background-color: #1C919E !important;
}
.subcat{
	background-color: #D98F34 !important;
}
</style>
